import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

type BulletsProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: number
    selectedIndex: number
    className: string
  }>

const Bullets = forwardRef<HTMLDivElement, BulletsProps>(
  ({ items = 0, selectedIndex = 0, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex w-full items-center justify-center space-x-spacing-2xs md:hidden',
          className
        )}
      >
        {Array.from({ length: items }, (_, index) => (
          <span
            key={index}
            style={{ left: `${8 * (items - 1) - selectedIndex * 16}px` }}
            className={cn(
              'relative block size-spacing-2xs rounded-full',
              'bg-surface-icon-light dark:bg-surface-icon-dark',
              'scale-0 transition-all duration-300 ease-out-cubic',
              (selectedIndex === index - 2 || selectedIndex === index + 2) &&
                'scale-[.33]',
              (selectedIndex === index - 1 || selectedIndex === index + 1) &&
                'scale-[.66]',
              selectedIndex === index && 'scale-100'
            )}
          />
        ))}
      </div>
    )
  }
)

export default Bullets
